import React from "react";
import { modalTypes } from "../../constants/modalTypes";

const IconShare = props => {
    let { icon } = props;

    return (
        <a
            data-test-id="icon-share"
            className="icon-share react-share ui_share"
            href="#"
            onClick={e => {
                e.preventDefault();
                props.downloadFlowNavigateToModalStep(
                    props.history,
                    modalTypes.ICON_SHARE,
                    { icon }
                );
            }}
        />
    );
};

export default IconShare;
